import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContextMenu } from "../../../../hooks/useContextMenu";
import useUserConfig from "../../../../hooks/useUserConfig";
import { DataOperation, VizContext } from "../../../../models/viz/operations/DataOperation";
import { EntityImageDisplay } from "../Shared/EntityImageDisplay";
import VizListItemContextMenu from "./VizListItemContextMenu";
import { Entity } from "../../../../models/viz/Entity";

export interface VisListItemProps {
    isSelected: boolean;
    entity: Entity;
    onClick: (entity: Entity, event: React.MouseEvent) => void;
    context: VizContext;
}

export function LargeIconListItem(props: VisListItemProps) {
    const { userConfig } = useUserConfig();
    const isMenuEnabled = userConfig.showCustomContextMenus;

    const { isShowingMenu, showMenu, hideMenu, menuCoords } = useContextMenu();

    const contextMenuOperations: DataOperation[] = [];
    if (props.context.view?.currentDataDescription !== undefined) {
        for (const operation of props.context.view.currentDataDescription.operations) {
            if (operation.context != "entity") {
                continue;
            }

            contextMenuOperations.push(operation);
        }
    }

    function handleOnContextMenu(event: React.MouseEvent) {
        if (!isMenuEnabled) {
            return;
        }

        event.preventDefault();

        // Select entity so that operations will apply to this entity
        if (!props.isSelected) {
            props.onClick(props.entity, event);
        }
        showMenu({ x: event.pageX, y: event.pageY });
    }

    return (
        <div
            onClick={(event) => {
                event.preventDefault();
                props.onClick(props.entity, event);
            }}
            onContextMenu={handleOnContextMenu}
            onMouseLeave={hideMenu}
            className={`viz-list-item${props.isSelected ? " selected" : ""}`}
            title={props.entity.getTitle()}
        >
            <VizListItemContextMenu
                show={isShowingMenu}
                operations={contextMenuOperations}
                coords={menuCoords}
                context={props.context}
            />

            {!isMenuEnabled && (
                <button
                    className="btn btn-secondary viz-list-item-show-context-menu fs-5"
                    onClick={(e) => {
                        // No stopping propagation, so the entity becomes selected
                        showMenu({ x: e.pageX, y: e.pageY });
                    }}
                >
                    <FontAwesomeIcon icon={faEllipsis}></FontAwesomeIcon>
                </button>
            )}

            <div className="viz-list-item-thumbnail position-relative">
                <EntityImageDisplay
                    mediaId={props.entity?.sourceObject?.mediaSource?.mediaId}
                    entityImage={props.entity?.images?.getMainImage()}
                />
            </div>
            <div className="viz-list-item-title">{props.entity.getTitle()}</div>
            <div className="viz-list-item-subtitle">{props.entity.getSubtitle()}</div>
        </div>
    );
}
